// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__caU4R","option":"SuperSelect_option__EWnrM"};